import React from "react";
import ExpertAvailabilitySetup from "./ExpertAvailabilitySetup";

const ExpertCorrectionAvailabilitySetup: React.FunctionComponent = () => {
  return <ExpertAvailabilitySetup title="expertCorrectionAvailability.header" availabilityType="correction" />;
};

export default ExpertCorrectionAvailabilitySetup;
